console.log('Cookiebot script loaded, checking for Cookiebot object...');

	// Check if Cookiebot exists immediately
	if (typeof Cookiebot !== 'undefined') {
	    console.log('Cookiebot object exists:', Cookiebot);
	} else {
	    console.log('Cookiebot object not found yet');
	}

	// Listen for all Cookiebot events to see which ones actually fire
	window.addEventListener('CookiebotOnLoad', function () {
	    console.log('CookiebotOnLoad fired');
	});

	window.addEventListener('CookiebotOnConsentReady', function () {
	    console.log('CookiebotOnConsentReady fired');
	});

	window.addEventListener('CookiebotOnDialogInit', function () {
	    console.log('CookiebotOnDialogInit fired');
	});

	// Get cookie by name function
    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    // InitialiConsent is first time true
    let initialConsent = getCookie('CookieConsent') == '' ? false : true;
    // Set expiry date for new cookies
    let expiryDate = new Date();
    expiryDate = expiryDate.setMonth(expiryDate.getMonth()+2);
    //const month = (expiryDate.getMonth() + 2) % 12;
    //expiryDate.setMonth(month);

    // If no cookie, turn rolex tracking off
    if (getCookie('rlx-consent') == '') {
        document.cookie = `rlx-consent=false; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
    }
    // If no rlx-marketing cookie, default to false until marketing consent is confirmed
    if (getCookie('rlx-marketing') == '') {
        document.cookie = `rlx-marketing=false; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
    }
    console.log("Rolex consent status on page load", getCookie('rlx-consent'));

    // If consent is loaded or changed.
	window.addEventListener('CookiebotOnLoad', function () {
	    console.log('CookiebotOnLoad fired');
        console.log('Cookiebot consent values:', {
            necessary: Cookiebot.consent.necessary,
            preferences: Cookiebot.consent.preferences,
            statistics: Cookiebot.consent.statistics,
            marketing: Cookiebot.consent.marketing,
            doNotTrack: Cookiebot.doNotTrack,
            declined: Cookiebot.declined
        });
	    // accept / decline shopify cookies
        window.Shopify?.customerPrivacy?.setTrackingConsent(!Cookiebot.declined, feedback);

        // User has accept Rolex cookies
        if (Cookiebot.consent.statistics && !Cookiebot.doNotTrack) {
            document.cookie = `rlx-consent=true; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;

            // Sent consent change to rolex iframe
            if (document.getElementById("rlx-corner") && !initialConsent) {
                document.getElementById("rlx-corner").contentWindow.postMessage("consentTrue","https://corners.rolex.com");
                document.getElementById("rlx-corner").contentWindow.postMessage("consentValidation", "https://corners.rolex.com");
            }

            // User has declined Rolex cookies
        } else {
            document.cookie = `rlx-consent=false; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
            // Sent consent change to rolex iframe
            if (document.getElementById("rlx-corner")) {
                document.getElementById("rlx-corner").contentWindow.postMessage("consentFalse","https://corners.rolex.com");
            }
        }

        // Set rlx-marketing cookie based on Marketing/Targeting consent category
        if (Cookiebot.consent.marketing && !Cookiebot.doNotTrack) {
            document.cookie = `rlx-marketing=true; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
        } else {
            document.cookie = `rlx-marketing=false; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
        }

        // InitialiConsent is the second time and after false
        initialConsent = false;
    });

    window.addEventListener('CookiebotOnAccept', function () {
	    console.log('CookiebotOnAccept fired');
		document.cookie = `rlx-consent=true; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
        // Update rlx-marketing based on marketing consent
        if (Cookiebot.consent.marketing && !Cookiebot.doNotTrack) {
            document.cookie = `rlx-marketing=true; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
        } else {
            document.cookie = `rlx-marketing=false; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
        }
	});

	window.addEventListener('CookiebotOnDecline', function () {
	    console.log('CookiebotOnDecline fired');
		document.cookie = `rlx-consent=false; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
        document.cookie = `rlx-marketing=false; path=/; expires=${expiryDate}; Secure; SameSite=Lax;`;
	});